import {createSelector} from 'reselect'
import {getStatesByCountry} from '../../selectors'

const getCreditCard = state => state.licenses.creditCard

export const getCardType = createSelector(
    getCreditCard,
    creditCard => creditCard.cardType
)

export const getCardNumber = createSelector(
    getCreditCard,
    creditCard => creditCard.cardNumber
)

export const getHolderName = createSelector(
    getCreditCard,
    creditCard => creditCard.holderName
)

export const getExpiredMonth = createSelector(
    getCreditCard,
    creditCard => creditCard.expiredMonth
)

export const getExpiredYear = createSelector(
    getCreditCard,
    creditCard => creditCard.expiredYear
)

export const getAddress = createSelector(
    getCreditCard,
    creditCard => creditCard.address
)

export const getCity = createSelector(
    getCreditCard,
    creditCard => creditCard.city
)

export const getZip = createSelector(
    getCreditCard,
    creditCard => creditCard.zip
)

export const getCountry = createSelector(
    getCreditCard,
    creditCard => creditCard.country
)

export const getState = createSelector(
    getCreditCard,
    creditCard => creditCard.state
)

export const getEditable = createSelector(
    getCreditCard,
    creditCard => creditCard.editable
)

export const isAddressFormOpen = createSelector(
    getCreditCard,
    creditCard => creditCard.isAddressFormOpen
)

export const isNeedToSaveCard = createSelector(
    getCreditCard,
    creditCard => creditCard.needToSaveCard
)

export const isStripeFieldsValid = createSelector(
    getCreditCard,
    creditCard => Object.values(creditCard.stripeFieldsValid).every(valueValid => valueValid)
)

export const isBillingAddressEntered = createSelector(
    getAddress,
    getCity,
    getZip,
    getCountry,
    getState,
    getStatesByCountry,
    (address, city, zip, country, region, statesByCountry) => {
        const hasStateIfNeeded = !statesByCountry[country] || !!statesByCountry[country] && region
        return !!(address && city && zip && country && hasStateIfNeeded)
    }
)




// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/selectors.js